define("shared/components/shared/profile-categorization/selected-types", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <a
    class="u--block u--text--center qa--categorize_back qa--categorize_reports_clear_text"
    {{on "click" @handleResetSelection}}
  >
    {{html-safe (t (concat @prefix "change_selection"))}}
  </a>
  
  <h2 class="tSC--card__title u--text--center">
    {{html-safe (t (concat "profile_categorization.industries." @industry))}}
    {{#if (eq @industry "other")}}
      {{svg-jar "help" class="o--icon--sm"}}
      <EmberTooltip @side="right">
        {{t "profile_categorization.reports.shared.other_tooltip_industry"}}
      </EmberTooltip>
    {{/if}}
  
    <span>|</span>
  
    {{html-safe (t (concat "profile_categorization.business_models." @businessModel))}}
    {{#if (eq @businessModel "other")}}
      {{svg-jar "help" class="o--icon--sm"}}
      <EmberTooltip @side="right">
        {{t "profile_categorization.reports.shared.other_tooltip_business_model"}}
      </EmberTooltip>
    {{/if}}
  </h2>
  */
  {
    "id": "fA2jfsRb",
    "block": "[[[11,3],[24,0,\"u--block u--text--center qa--categorize_back qa--categorize_reports_clear_text\"],[4,[38,0],[\"click\",[30,1]],null],[12],[1,\"\\n  \"],[1,[28,[35,1],[[28,[37,2],[[28,[37,3],[[30,2],\"change_selection\"],null]],null]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"h2\"],[14,0,\"tSC--card__title u--text--center\"],[12],[1,\"\\n  \"],[1,[28,[35,1],[[28,[37,2],[[28,[37,3],[\"profile_categorization.industries.\",[30,3]],null]],null]],null]],[1,\"\\n\"],[41,[28,[37,5],[[30,3],\"other\"],null],[[[1,\"    \"],[1,[28,[35,6],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n    \"],[8,[39,7],null,[[\"@side\"],[\"right\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"profile_categorization.reports.shared.other_tooltip_industry\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,1],[12],[1,\"|\"],[13],[1,\"\\n\\n  \"],[1,[28,[35,1],[[28,[37,2],[[28,[37,3],[\"profile_categorization.business_models.\",[30,4]],null]],null]],null]],[1,\"\\n\"],[41,[28,[37,5],[[30,4],\"other\"],null],[[[1,\"    \"],[1,[28,[35,6],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n    \"],[8,[39,7],null,[[\"@side\"],[\"right\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"profile_categorization.reports.shared.other_tooltip_business_model\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13]],[\"@handleResetSelection\",\"@prefix\",\"@industry\",\"@businessModel\"],false,[\"on\",\"html-safe\",\"t\",\"concat\",\"if\",\"eq\",\"svg-jar\",\"ember-tooltip\"]]",
    "moduleName": "shared/components/shared/profile-categorization/selected-types.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});